import React from "react";
import "antd/dist/antd.css";
import Top from "../../../components/common/Top";
import Footer from "../../../components/common/Footer";
import FreeTrial from "../../../components/FreeTrial";
import Banner from "../common/Banner";
import { Layout } from "antd";
import actionWays from "../../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../../inphone.scss";
import Customized from "../common/Customized";
import ServiceValue from "./ServiceValue";
import Challenge from "./Challenge";
import SolveProblems from "./SolveProblems";
import WarrantyManagement from "./WarrantyManagement";
import Product from "./Product";
import LifeCycle from "./LifeCycle";
import { adaptation } from "../../../utils/adaptation";
import { withTranslation } from "react-i18next";
import "../common/index.scss";
const { Content } = Layout;
const productObj = {
  titleObj: {
    title: "产品功能",
    details: "",
  },
  bgColor: "#f7fafd",
  imgUrl: require("../../../assets/images/solution/common/banner3.png").default,
  title: "智能资产盘点",
  details:
    "采用 AI 识别技术，自动完成资产盘点，准确率达 99.9%。支持批量处理，大幅提升盘点效率。",
  list: ["AI 自动识别分类", "批量数据处理", "实时数据反馈"],
};
class Guaranteed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
    };
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  }
  render() {
    const { t } = this.props;
    const solution_asset = t("solution_asset", {
      returnObjects: true,
    });
    return (
      <Layout>
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {/* banner图 start*/}
          <Banner active={2} />
          {/* banner图 end*/}

          {/* 服务价值 start*/}
          <ServiceValue />
          {/* 服务价值 end*/}

          {/* 全生命周期 start*/}
          <LifeCycle />
          {/* 全生命周期 end*/}

          {/* 技术架构 start*/}
          <Customized customizedObj={solution_asset.asset3} />
          {/* 技术架构 end*/}

          {/* 挑战 start*/}
          <Challenge />
          {/* 挑战 end*/}

          {/* 解决问题 start*/}
          <SolveProblems />
          {/* 解决问题 end*/}

          {/* 保修管理系统 start*/}
          <WarrantyManagement />
          {/* 保修管理系统 end*/}
          {/* 锚点 start*/}
          {/* <AnchorPoint anchorPointList={anchorPointList} /> */}
          {/* 锚点 end*/}
          {/* 内外协同 */}
          {/* <Customized customizedObj={customized1} /> */}
          {/* 产品功能 start */}
          <Product productObj={productObj} />
          {/* 产品功能 end */}
          {/* 在线体验 start*/}
          <FreeTrial />
          {/* 在线体验 end*/}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Guaranteed)));
